/**
 * LA Galaxy Theme Configuration
 * Brand colors: Navy Blue (#00245D), Gold (#FFD200), White
 */

const galaxyTheme = {
    // Client identification
    clientId: 'galaxy',
    clientName: 'LA Galaxy',

    // Logo configuration - TODO: Add Galaxy logos
    logos: {
        primary: require('../../components/Login/images/lagalaxy.png'), // Replace with galaxy logo
        primaryHeight: '85px',
        secondary: require('../../components/Login/images/theteam.png'),
        secondaryHeight: '52px',
    },

    // Channel colors and gradients - Galaxy navy/gold palette (lighter gradients)
    channels: {
        social: {
            color: '#004C97',
            gradient: ['#5B9BD5', '#2E75B6'],
        },
        digital: {
            color: '#FFD200',
            colorHex: '#FFD200',
            gradient: ['#FFE44D', '#FFD200'],
        },
        highlights: {
            color: '#FF8C00',
            gradient: ['#FFB347', '#FFA500'],
        },
        linear: {
            color: '#5DADE2',
            colorAlt: '#2E86AB',
            gradient: ['#85C1E9', '#5DADE2'],
        },
        tv: {
            color: '#2E86AB',
            gradient: ['#85C1E9', '#5DADE2'],
        },
        invenue: {
            color: '#2E86AB',
            gradient: ['#85C1E9', '#5DADE2'],
        },
        ooh: {
            color: '#8E44AD',
            gradient: ['#BB8FCE', '#A569BD'],
        },
        sponsorship: {
            color: '#58D68D',
            gradient: ['#82E0AA', '#58D68D'],
        },
    },

    // Gradient card text color (black works on lighter gradients)
    gradientCardText: 'black',

    // Background colors - Navy-tinted dark theme
    backgrounds: {
        page: '#0A0A12',
        loginPage: 'rgb(10, 15, 25)',
        panel: '#0D1421',
        panelDark: 'hsl(220 30% 8%)',
        panelMid: 'hsl(220 25% 14%)',
        panelAlt: 'hsl(220 25% 18%)',
        panelLight: 'hsl(220 20% 25%)',
        modal: '#1A2332',
    },

    // Text colors
    text: {
        primary: 'white',
        secondary: '#FFD200',
        highlight: '#FFD200',
        onLight: '#00245D',
        link: '#5DADE2',
        wheat: '#F5DEB3',
    },

    // Button colors - must use Semantic UI color names
    buttons: {
        primary: 'yellow',
        dashboard: 'blue',
        viz3d: 'teal',
        rawdata: 'grey',
        apply: 'blue',
        save: 'green',
        reset: 'blue',
        refresh: 'teal',
    },

    // Accent colors - teal on navy for high contrast + readable text (primary must be Semantic UI color name for Label)
    accents: {
        primary: 'teal',  // High contrast on navy + readable white text (yellow had white-on-yellow issue)
        secondary: '#FFD200',
        tertiary: '#2E86AB',
        tab1: '#FFD200',
        tab2: '#5DADE2',
        tab3: '#004C97',
    },

    // Navigation colors
    navigation: {
        background: '#0A0A12',
        iconColor: '#5DADE2',
        iconActiveColor: '#FFD200',
        iconHighlight: '#FFD200',
    },

    // Label colors - must use Semantic UI color names for ribbon to work
    labels: {
        brand: 'orange',   // Warm color with readable white text (yellow had readability issue)
        asset: 'teal',     // High contrast on navy + readable text (was yellow)
        channel: 'olive',  // Distinguishes from asset
        comparison: 'blue',
        ribbon: 'blue',
    },

    // Shadow styles - Navy tint
    shadows: {
        card: 'hsl(220 30% 25%) 0 0 4px',
        cardLarge: 'hsl(220 30% 25%) 0 0 8px',
        image: '#020208 9px 10px 20px 2px',
    },

    // Gauge/Speedometer colors
    gauge: {
        stages: [
            [0.09, '#C0392B'],
            [0.25, '#E74C3C'],
            [0.45, '#F39C12'],
            [0.7, '#5DADE2'],
            [1, '#FFD200'],
        ],
        text: '#fff',
        detail: '#1A2332',
        shadow: '#FFD200',
    },

    // Table row color palette - Navy shades
    tableRows: [
        '#0D1421',
        '#152238',
        '#1A3050',
        '#004C97',
        '#2E5984',
        '#3D6B99',
        '#1E4D6B',
        '#2A5F7A',
        '#1B4D5C',
        '#2C4A5E',
        '#3A5A6E',
        '#284B5B',
        '#1E3D4D',
    ],

    // Form element colors
    forms: {
        loginFormBackground: '#0A0A12',
        loginFormOpacity: '0.85',
        dropdownBackground: '#004C97',
        dropdownText: 'white',
        inputBackground: '#1A2332',
        inputText: '#FFD200',
    },

    // Progress bar colors - gold fill on navy for high contrast
    progressBar: {
        background: 'hsl(220 25% 25%)',
        fill: '#FFD200',  // Gold for high contrast (was navy blue)
        tiny: '#1A2332',
    },

    // Scrollbar colors
    scrollbar: {
        track: '#0D1421',
        thumb: '#1A2332',
    },

    // Chart-specific colors
    charts: {
        axisLabel: '#8899AA',
        axisLine: 'white',
        tooltipBackground: '#1A2332',
    },
};

export default galaxyTheme;
